import * as Yup from 'yup';

export const UserInfoFilterSchema = Yup.object().shape({
  startDate: Yup.string(),
  endDate: Yup.string(),
  status: Yup.string(),
});

export type UserInfoFilterDataType = Yup.InferType<typeof UserInfoFilterSchema>;

type InitialValues = {
  startDate: string;
  endDate: string;
  status: string;
};

export const UserInfoFilterSchemaInitialValues: InitialValues = {
  startDate: '',
  endDate: '',
  status: '',
};
